module.exports = __webpack_public_path__ + "media/win.a5e0c4e9.wav";